export default __webpack_public_path__ + "static/media/NHaasGroteskTXPro-65Md.13fc4bcc.ttf";